var XPortal = XPortal || {};
XPortal.GridMap = (function () {
    var mpinStatic = { iconUrl: '/content/images/pin-center.png', iconAnchor: [32, 64], popupAnchor: [1, -66] };
    var mPin = null;
    var self =
    {
        geocache: null,
        Init: function (cntr) {
            cntr = $(cntr ? cntr : "body");
            cntr.find(".gridmap-viewcontainer").each(function () {
                InitFor(this);
            });
        },
        cachedLtLgByAddress: function (dAddr, onNoFound) {
            var d = $.Deferred();
            if (self.geocache == null && window.localStorage) self.geocache = JSON.parse(window.localStorage.getItem('geocacheltlgbyaddr'));
            if (self.geocache == null) self.geocache = [];
            if (dAddr && dAddr.length) dAddr = dAddr.trim().toLowerCase();
            if (!dAddr.length) d.resolve(null);
            else {
                var cr = _.find(self.geocache, function (ci) {
                    return ci.a == dAddr;
                });
                if (!cr) {
                    onNoFound(dAddr).fail(function () { d.resolve(null); })
                        .done(function (dlt, dlg) {
                            var cr = _.find(self.geocache, function (ci) {
                                return ci.a == dAddr;
                            });
                            if (!cr) self.geocache.push({ a: dAddr, lt: dlt, lg: dlg });
                            d.resolve(dlt, dlg);
                            setTimeout(function () { window.localStorage.setItem('geocacheltlgbyaddr', JSON.stringify(self.geocache)); }, 2000);
                        });
                } else d.resolve(cr.lt, cr.lg);
            }
            return d.promise();
        },
        GeoLtLgByAddress: function (dataItemAddress) {
            if ((!dataItemAddress) || dataItemAddress.length == 0) {
                var r = $.Deferred();
                res.reject();
                return r.promise();
            }
            return self.cachedLtLgByAddress(dataItemAddress, function () {
                var xgdef = $.Deferred();

                if (!self.geocoder && typeof (google) != "undefined") self.geocoder = google && google.maps ? new google.maps.Geocoder() : null;
                if (!self.geocoder) xgdef.reject();
                else
                    self.geocoder.geocode({ 'address': dataItemAddress }, function (results, status) {
                        if (results && results.length > 0) xgdef.resolve(results[0].geometry.location.lat(), results[0].geometry.location.lng(), results, status);
                        else xgdef.reject();
                    });
                return xgdef.promise();
            });
        },
        getOptions: function (c) {
            var ostr = c.attr("data-opts");
            var o = ostr && ostr.length ? eval("ostr=" + ostr) : {};
            var so = [];
            _.each(o.StaticPoints, function (p) {
                var c = p && (p.Latitude || p.Latitude == 0) && (p.Longitude || p.Longitude == 0) ? [p.Latitude, p.Longitude] : null;
                if (c) {
                    p.Point = c;
                    so.push(p);
                }
            });
            o.StaticPoints = so;

            if (!o.Center && o.StaticPoints && o.StaticPoints.length > 0) o.Center = o.StaticPoints[0];
            if (!o.Center) o.Center = { Point: [50.25846, 4.2867] };
            o.MaxZoom = o.MaxZoom > 0 && o.MaxZoom < 25 ? o.MaxZoom : 20;
            o.MinZoom = o.MinZoom >= 0 && o.MinZoom <= o.MaxZoom ? o.MinZoom : 0;
            o.Zoom = o.Zoom && o.Zoom > 0 && o.Zoom <= o.MaxZoom ? o.Zoom : 6;
            o.ZoomDelta = o.ZoomDelta > 0 && o.ZoomDelta <= o.MaxZoom ? o.ZoomDelta : 0.1;
            o.StaticMarkers = [];
            o.SourceControl = $(c.attr("data-src"));
            return o;
        },
        ReloadMarkers: function (m, o, d, createMarker, removeMarker) {
            var r = $.Deferred();
            if (o.Markers && o.Markers.length > 0) {
                while (o.Markers.length > 0)
                    removeMarker(o.Markers.pop());
            }
            o.Markers = [];
            var allpoints = $.map(d, function (di) {
                var ri = $.Deferred();
                createMarker(di).then(function (mri) {
                    if (mri) {
                        if (mri.length) _.each(mri, function (xmri) { o.Markers.push(xmri); });
                        else o.Markers.push(mri);
                    }
                    ri.resolve();
                });
                return ri.promise();
            });
            $.when.apply($, allpoints).done(function () { r.resolve(); });
            return r.promise();
        },
        findMarkers: function (m, o, id) {
            return _.filter(o.Markers ? o.Markers : [], function (x) {
                return x.xuid == id;
            });
        },
        _ensureGoogleMapApi: function (cntr) {
            if (self.gmapinit) return;
            self.gmapinit = true;
            var msrc = 'https://maps.googleapis.com/maps/api/js?key=' + ($(cntr).attr("data-mapapikey")) + '&callback=XPortal.GridMap._genericCBack';
            var mapScript = document.createElement('script');
            mapScript.src = msrc;
            document.head.appendChild(mapScript);
        },
        _genericCBack: function () {
            if (console && console.log) console.log("Init google map callback.version: " + (google && google.maps ? google.maps.version : "--null-") + " ");
        }

    };

    function InitFor(cnrol) {
        cnrol = cnrol ? $(cnrol) : false;
        if (!(cnrol) || cnrol.length < 1) return;
        var pr = cnrol.attr("data-provider");
        if (!pr || pr.length < 1) return;
        if (cnrol.attr("data-processed") == "1") return;
        cnrol.attr("data-processed", "1");

        if (pr.toLowerCase() === "leaflet") InitForLeaflet(cnrol, pr);
        if (pr.toLowerCase() === "leafletgmap") InitForLeafletGmap(cnrol, pr);
        else if (pr.toLowerCase() === "gmap") InitForGoogleMaps(cnrol, pr);
    }

    function InitForGoogleMaps(cnrol) {
        cnrol = cnrol ? $(cnrol) : false;
        if (!cnrol || cnrol.length < 1) return;
        waitFor(function () {
            self._ensureGoogleMapApi(cnrol);
            if (typeof (google) == "undefined") return false;

            var moptions = self.getOptions(cnrol);
            var infowindow = new google.maps.InfoWindow();
            moptions.dataToMarker = function (xmarker) {
                return new google.maps.Marker({
                    position: { lat: xmarker.lt, lng: xmarker.lg },
                    icon: xmarker.i ? xmarker.i : "",
                    title: xmarker.p
                });
            };
            moptions.removeMarker = function (rmarker) {
                if (rmarker) {
                    if (typeof (rmarker.setMap) == "function") rmarker.setMap(null);
                    if (typeof (rmarker.setMap) == "function") rmarker.setMap(null);
                    rmarker = null;
                }
            };
            moptions.addMarker = function (amarker) {
                if (amarker) amarker.setMap(map);
            };
            moptions.zoomToMarkers = function (someMrks) {
                if (someMrks && someMrks.length) {
                    var bounds = new google.maps.LatLngBounds();
                    _.each(someMrks, function (mark) {
                        bounds.extend(mark.getPosition());
                    });
                    map.fitBounds(bounds);
                }
                infowindow.close();
                clearInterval(moptions.zoomInterval);
                if (moptions.FlyToSelection) {
                    moptions.zoomIntervalInx = 0;
                    if (someMrks.length > 1) {
                        moptions.zoomInterval = setInterval(function () {
                            moptions.zoomIntervalInx = moptions.zoomIntervalInx < someMrks.length ? moptions.zoomIntervalInx : 0;
                            var sm = someMrks[moptions.zoomIntervalInx];
                            infowindow.setContent(sm.title);
                            infowindow.open(map, sm);
                            moptions.zoomIntervalInx++;
                        }, 3000);
                    } //else someMrks[moptions.zoomIntervalInx].openPopup();
                }
            };

            var map = new google.maps.Map(cnrol[0], {
                zoom: moptions.Zoom,
                minZoom: moptions.MinZoom, maxZoom: moptions.MaxZoom,
                mapTypeId: google.maps.MapTypeId.HYBRID,
                center: { lat: moptions.Center.Latitude, lng: moptions.Center.Longitude }
            });

            setupGMapStaticPoints(moptions, map);
            setupMapGridBinding(moptions, map);
            setupLeafletDynamicPoints(moptions, cmap, cnrol, mpinStatic);
            return true;
        }, waitFor);
    }
    function InitForLeaflet(cnrol) {
        waitFor(function () {
            if (typeof (L) == "undefined") return false;

            mPin = mPin ? mPin : new L.Icon({ iconUrl: '/content/images/pin-pink-64.png', iconAnchor: [16, 32], popupAnchor: [1, -30] });
            if (console && console.log) console.log("InitForLeaflet:" + L.version, cnrol.attr("id"));
            var moptions = self.getOptions(cnrol);
            var cmap = L.map(cnrol.attr("id"), {
                center: moptions.Center.Point, zoom: moptions.Zoom, minZoom: moptions.MinZoom, maxZoom: moptions.MaxZoom,
                zoomDelta: moptions.ZoomDelta, zoomSnap: 0
                , trackResize: false
            });
            moptions.hereapp = { i: ($(cnrol).attr("data-happid")), c: ($(cnrol).attr("data-happcode")) };
            if (moptions.hereapp.i && moptions.hereapp.c && moptions.hereapp.i.trim().length && moptions.hereapp.c.trim().length) {
                //https://developer.here.com/plans
                // up to :250K TRANSACTIONS PER MONTH free
                var HERE_hybridDay = L.tileLayer('https://{s}.{base}.maps.cit.api.here.com/maptile/2.1/{type}/{mapID}/hybrid.day/{z}/{x}/{y}/{size}/{format}?app_id={app_id}&app_code={app_code}&lg={language}', {
                    attribution: 'Map &copy; 1987-2023 <a href="https://developer.here.com">HERE</a>',
                    subdomains: '1234', mapID: 'newest',
                    app_id: moptions.hereapp.i,//'lKpUJspW7oOxTgs2O66d',//'tFZyfnyJAmhfh5gdoGcR',
                    app_code: moptions.hereapp.c,//'JHePJ12EU620omLOl5GAaA',//'vJ8o9OCQ1o0Y2wwbRspzSA',
                    base: 'aerial', maxZoom: 20, type: 'maptile', language: 'eng', format: 'png8', size: '256'
                }).addTo(cmap);
            } else {
                //https://leaflet-extras.github.io/leaflet-providers/preview/
                //https://wiki.osmfoundation.org/wiki/Licence/Licence_and_Legal_FAQ#What_is_the_licence.2C_how_can_I_use_it.3F
                var CartoDB_VoyagerLabelsUnder = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png', {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
                    subdomains: 'abcd',
                }).addTo(cmap);
            }
            L.control.scale().addTo(cmap);
            moptions = ensureLeafletOptions(moptions, cmap, mPin);
            setupLeafletStaticPoints(moptions, cmap);
            setupMapGridBinding(moptions, cmap);
            setupLeafletDynamicPoints(moptions, cmap, cnrol, mpinStatic);
            window.addResizeListener(cnrol[0], function () {
                if (cmap) cmap.invalidateSize();
            });
            if (cmap) cmap.invalidateSize();
            return true;
        }, waitFor);
    }
    function InitForLeafletGmap(cnrol, prname) {
        waitFor(function () {
            self._ensureGoogleMapApi(cnrol);
            if (typeof (L) == "undefined") return false;
            if (typeof (google) == "undefined") return false;
            if (console && console.log) console.log("InitForLeaflet google map:" + L.version, cnrol.attr("id"));
            mPin = mPin ? mPin : new L.Icon({ iconUrl: '/content/images/pin-pink-64.png', iconAnchor: [16, 32], popupAnchor: [1, -30] });
            var moptions = self.getOptions(cnrol);
            var cmap = L.map(cnrol.attr("id"), {
                center: moptions.Center.Point, zoom: moptions.Zoom, minZoom: moptions.MinZoom, maxZoom: moptions.MaxZoom,
                zoomDelta: moptions.ZoomDelta, zoomSnap: 0
                , trackResize: false
            });
            var roads = L.gridLayer.googleMutant({
                type: 'hybrid'	// valid values are 'roadmap', 'satellite', 'terrain' and 'hybrid'
            }).addTo(cmap);

            moptions = ensureLeafletOptions(moptions, cmap, mPin);
            setupLeafletStaticPoints(moptions, cmap);
            setupMapGridBinding(moptions, cmap);
            setupLeafletDynamicPoints(moptions, cmap, cnrol, mpinStatic);
            window.addResizeListener(cnrol[0], function () {
                if (cmap) cmap.invalidateSize();
            });
            if (cmap) cmap.invalidateSize();
            return true;
        }, waitFor);
    }

    function ensureLeafletOptions(moptions, cmap) {
        moptions.dataToMarker = function (xmarker) {
            if (!xmarker) return null;
            var mcr = null;
            if (xmarker.i) {
                //custom icon
                var o = null;
                if (xmarker.i[0] === "/") {
                    try { o = new L.Icon({ iconUrl: xmarker.i, iconAnchor: [32, 64], popupAnchor: [1, -32] }); } catch (ex) { if (console && console.log) console.log("handling point creation error:" + ex); };
                } else o = new L.Icon(o);
                if (o) {
                    mcr = L.marker(L.latLng(xmarker.lt, xmarker.lg), { icon: o });
                    mcr.CustomIcon = o;
                }
            }
            mcr = mcr ? mcr : L.marker(L.latLng(xmarker.lt, xmarker.lg), { icon: mPin });
            if (mcr && xmarker.p) mcr.bindPopup(xmarker.p);
            ensureMarkerIcon(mcr, mPin);
            return mcr;
        };
        moptions.removeMarker = function (rmarker) {
            if (rmarker) {
                if (typeof (rmarker.removeFrom) == "function") rmarker.removeFrom(cmap);
                if (typeof (rmarker.remove) == "function") rmarker.remove();
                rmarker = null;
            }
        };
        moptions.addMarker = function (amarker) {
            if (amarker && typeof (amarker.addTo) == "function")
                amarker.addTo(cmap);
        };
        moptions.zoomToMarkers = function (someMrks, skipmoveToCenter) {
            if (someMrks && someMrks.length) {
                cmap.fitBounds(_.map(someMrks, function (m) {
                    return m._latlng;
                }), { padding: [100, 100], maxZoom: moptions.MaxZoom });
                if (!skipmoveToCenter) cmap.panTo(someMrks[0]._latlng);
            }

            clearInterval(moptions.zoomInterval);
            if (moptions.FlyToSelection) {
                moptions.zoomIntervalInx = 0;
                if (someMrks.length > 1) {
                    moptions.zoomInterval = setInterval(function () {
                        moptions.zoomIntervalInx = moptions.zoomIntervalInx < someMrks.length ? moptions.zoomIntervalInx : 0;
                        someMrks[moptions.zoomIntervalInx].openPopup();
                        moptions.zoomIntervalInx++;
                    }, 3000);
                } //else someMrks[moptions.zoomIntervalInx].openPopup();
            }
            cmap.invalidateSize();
        };
        return moptions;
    }

    function setupLeafletStaticPoints(moptions, cmap) {
        if (moptions.StaticPoints.length > 0)
            _.each(moptions.StaticPoints, function (p) {
                var sicon = $.extend({}, p, mpinStatic);
                if (sicon.ImageUrl) sicon.iconUrl = sicon.ImageUrl;
                var m = L.marker(L.latLng(p.Point[0], p.Point[1]), { icon: new L.Icon(sicon), draggable: false }).addTo(cmap);
                ensureMarkerIcon(m, mpinStatic);
                if (sicon.PopupMsg) m.bindPopup(sicon.PopupMsg);
            });
    }
    function setupGMapStaticPoints(moptions, cmap) {
        if (moptions.StaticPoints.length < 1) return;
        _.each(moptions.StaticPoints, function (point) {
            var marker = new google.maps.Marker({
                position: { lat: point.Point[0], lng: point.Point[1] },
                icon: point.ImageUrl ? point.ImageUrl : "",
                map: cmap, title: point.PopupMsg
            });
            moptions.StaticMarkers.push(marker);
        });
    }

    function setupMapGridBinding(moptions, cmap) {
        if (!(moptions.SourceControl)) return;
        var onRequestEnd = function (e, r) {
            onRequestEndGeneric(e, r, cmap, moptions, function () {
                if (moptions.ShowOnlySelection) return;
                _.each(moptions.Markers, moptions.addMarker);
                moptions.zoomToMarkers(moptions.Markers);
            });
        };
        moptions.SourceControl.on("grid.requestEnd", onRequestEnd);
        var i = 1000;
        waitFor(function () {
            var kdata = moptions.SourceControl.data("kendoGrid");
            if (!kdata && i-- > -1) return false;
            if (i < 0) return true;
            kdata.bind("change", function () {
                var sel = this.dataItem(this.select());
                var selId = sel ? sel.UniqueId : "";
                var selMarkers = self.findMarkers(cmap, moptions, selId);
                //show selected markers
                if (moptions.ShowOnlySelection && moptions.Markers) {
                    _.each(moptions.Markers, function (m) {
                        if (m.id != selId) moptions.removeMarker(m);
                    });
                    _.each(selMarkers, moptions.addMarker);
                }
                moptions.zoomToMarkers(selMarkers);
            });

            if (kdata.dataSource.iRequestEnd && !moptions.isinitialized) onRequestEnd(null, kdata.dataSource.iRequestEnd);//when grid already with data,but we not processed this data yet
            return true;
        }, waitFor);

    }
    function onRequestEndGeneric(e, r, cmap, moptions, onDone) {
        moptions.isinitialized = true;
        clearTimeout(moptions.crequest);
        r.responseNr = isNaN(moptions.crequestNr) ? -1 : moptions.crequestNr + 1;
        moptions.crequest = setTimeout(function () {
            self.ReloadMarkers(cmap, moptions, r.response, function (di) {
                var mresult = $.Deferred();
                var mcrs = [];
                if (r.responseNr < moptions.crequestNr) mre.resolve();
                else {
                    $.when.apply($, $.map(moptions.DynamicPoints, function (dp) {
                        var dfd = $.Deferred();
                        getPointByData(di, dp)
                            .fail(function () { dfd.resolve(null); })
                            .done(function (xmarker) {
                                xmarker = xmarker == null ? null : moptions.dataToMarker(xmarker);
                                if (xmarker) {
                                    mcrs.push(xmarker);
                                    xmarker.xuid = di ? di.UniqueId : null;
                                }
                                dfd.resolve(xmarker);
                            });
                        return dfd.promise();
                    })).fail(function () { mresult.resolve(mcrs); }).done(function () {
                        mresult.resolve(mcrs);
                    });
                }
                return mresult.promise();
            }, moptions.removeMarker).done(onDone);
        }, 500);
    }

    function getPointByData(di, dp) {
        var dfd = $.Deferred();
        var r = {};
        r.lt = dp.Latitude !== "" ? getDecimalFieldVal(di, dp.Latitude) : null;
        r.lg = dp.Longitude !== "" ? getDecimalFieldVal(di, dp.Longitude) : null;
        r.a = XPortal.Template.ReplaceFormatString(dp.AddressField, null, di, {});
        r.i = XPortal.Template.ReplaceFormatString(dp.MarkerField, null, di, {});
        r.p = XPortal.Template.ReplaceFormatString(dp.MarkerInfo, null, di, {});
        if (r.i) {
            if (r.i.trim()[0] === "{") {
                try { r.i = eval("rxi=" + r.i); } catch (ex) { console.warn(ex); };
            } else r.i = '/content/images/pins/' + r.i;
        }
        if (r.lt !== null && r.lg !== null && !isNaN(r.lt) && !isNaN(r.lg))
            dfd.resolve(r);
        else {
            if (r.a) {
                self.GeoLtLgByAddress(r.a).fail(function () {
                    dfd.resolve(null);
                }).done(function (xlt, xlg) {
                    r.lt = xlt; r.lg = xlg;
                    if (r.lt !== null && r.lg !== null && !isNaN(r.lt) && !isNaN(r.lg)) dfd.resolve(r);
                    else dfd.resolve(null);
                });
            } else dfd.resolve(null);
        }
        return dfd.promise();
    }
    function ensureMarkerIcon(mrc, mrcDefault) {
        image_url = mrc && mrc.options && mrc.options.icon && mrc.options.icon.options && mrc.options.icon.options.iconUrl ? mrc.options.icon.options.iconUrl : "";
        if (image_url && image_url.length > 0) {
            $.get(image_url)
                .done(function () { }).fail(function () {
                    // Image doesn't exist - do something else.
                    updateMarkerImage(mrc, mrcDefault.iconUrl);
                });
        } else updateMarkerImage(mrc, mrcDefault.iconUrl);
    }
    function updateMarkerImage(mrc, iconUrl) {
        mrc.options.icon.options.ImageUrl = iconUrl;
        mrc.options.icon.options.iconUrl = iconUrl;
        mrc.setIcon(mrc.options.icon);
    }

    function getDecimalFieldVal(d, n, onNfound) {
        var r = getStringFieldVal(d, n, onNfound);
        return XPortal.Grid.ConvertToNumber(r);
    }
    function getStringFieldVal(d, n, onNfound) {
        var nl = n.toLowerCase();
        var f = _.find(d.Fields, function (f) {
            return f.Name.toLowerCase() == nl;
        });
        if (f && f.StringValue) return f.StringValue;
        return onNfound ? onNfound() : null;
    }


    function setupLeafletDynamicPoints(moptions, cmap, cnrol, mpinStatic) {
        if (!moptions.DynamicPointsPaths || moptions.DynamicPointsPaths.length < 1) return;
        const postData = JSON.stringify({ nodeId: moptions.nodeId, points: moptions.DynamicPointsPaths, parentInfo: moptions.parentInfo });
        return jQuery.ajax({
            url: XPortal.Utils.EnsureInProfile("/umbraco/Surface/CustomUI/MapPoints"), type: 'POST', dataType: 'json', cache: false, contentType: "application/json; charset=utf-8",
            data: postData,
            headers: { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken(), "nParentInfo": moptions.parentInfo }
        }).then(function (response) {
            if (response && response.Items) {
                let markers = [];
                _.each(_.groupBy(response.Items, ix => ix.Key), (gx, gk) => {
                    let stx = moptions.DynamicPointsPaths.find(ox => ox.Key = gk);
                    let points = [];
                    response.Items.map(x => {
                        var p = renderLefleatMapPoint(moptions, cmap, x, mpinStatic, stx);
                        if (p._latlng) points.push(p._latlng);
                        markers.push(p);
                        return p;
                    });
                    if (stx.DrawLine && points && points.length) {
                        let lopts = stx.LineOpts || {};
                        if (lopts.Animate)
                            L.polyline.antPath(points, { use: L.polyline, delay: 400, dashArray: [10, 10], weight: lopts.Thickness > 0 ? lopts.Thickness : 1, color: lopts.Color ? lopts.Color : "#ff0000", pulseColor: lopts.PulseColor ? lopts.PulseColor : "#00FFFF" }).addTo(cmap);
                        else
                            L.polyline(points, { color: lopts.Color ? lopts.Color : "#ff0000", weight: lopts.Thickness > 0 ? lopts.Thickness : 1, opacity: 0.5, smoothFactor: 1, dashArray: '5, 5', dashOffset: '0' }).addTo(cmap);
                    }
                });
                setTimeout(function () {
                    moptions.zoomToMarkers(markers, true);
                }, 1000);
            }
        }, function (err) {

        });
    };
    function renderLefleatMapPoint(moptions, cmap, point, mpinStatic, stx) {
        stx = stx || { iconAnchorX: 14, iconAnchorY: 14, popupAnchorX: 0, popupAnchorY: -9 };
        const sicon = $.extend({}, point, mpinStatic, { iconAnchor: [stx.iconAnchorX, stx.iconAnchorY], popupAnchor: [stx.popupAnchorX, stx.popupAnchorY] });
        if (sicon.Img) sicon.iconUrl = sicon.Img;
        let p = [XPortal.Grid.ConvertToNumber(point.Lat), XPortal.Grid.ConvertToNumber(point.Lng)];
        let m = L.marker(L.latLng(p[0], p[1]), { icon: new L.Icon(sicon), draggable: false }).addTo(cmap);
        ensureMarkerIcon(m, mpinStatic);
        if (sicon.Msg) m.bindPopup(sicon.Msg);
        return m;
    };
   
    function DrawCurveBetweenpoints(cmap, latlng1, latlng2, pathOptions) {
        //latlng1 = [23.634501, -102.552783],latlng2 = [17.987557, -92.929147];//https://elfalem.github.io/Leaflet.curve/src/leaflet.curve.js
        var offsetX = latlng2[1] - latlng1[1], offsetY = latlng2[0] - latlng1[0];

        var r = Math.sqrt(Math.pow(offsetX, 2) + Math.pow(offsetY, 2)), theta = Math.atan2(offsetY, offsetX);
        var thetaOffset = (3.14 / 10);
        var r2 = (r / 2) / (Math.cos(thetaOffset)), theta2 = theta + thetaOffset;
        var midpointX = (r2 * Math.cos(theta2)) + latlng1[1], midpointY = (r2 * Math.sin(theta2)) + latlng1[0];
        var midpointLatLng = [midpointY, midpointX];
        //latlngs.push(latlng1, midpointLatLng, latlng2);
        pathOptions = pathOptions || { color: 'red', weight: 3 };
        return L.curve(['M', latlng1, 'Q', midpointLatLng, latlng2], pathOptions).addTo(cmap);
    };

    function waitFor(onAction, onFalse) {
        if (!onAction()) {
            setTimeout(function () { onFalse(onAction, onFalse); }, 100);
        }
    };

    return self;
}());